import buttonSizeVariants from "@insite/mobius/Button/buttonSizeVariants";
// Verndale Customization: Change height to 40px to match design

buttonSizeVariants.small = {
    height: 30,
    fontSize: 16,
    padding: "0px 11px",
    icon: 13,
    iconPadding: 5,
    mobile: {
        height: 30,
        padding: "0px 11px",
    },
} as any;

buttonSizeVariants.medium = {
    height: 40,
    fontSize: 16,
    padding: "0px 11px",
    icon: 13,
    iconPadding: 5,
    mobile: {
        height: 40,
        padding: "0px 11px",
    },
} as any;

buttonSizeVariants.large = {
    height: 50,
    fontSize: 18,
    padding: "0 30px",
    icon: 20,
    iconPadding: 9,
    mobile: {
        height: 40,
        padding: "0px 11px",
    },
} as any;

// Verndale Customization: Change height to 40px to match design
// export default buttonSizeVariants;
